import { StyleSheet } from 'react-native'

export const DrawerHamburgerStyles = StyleSheet.create({
	drawer: {
		flex: 1,
		alignItems: 'center',
		justifyContent: "center",
	}
});
